import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const referrerGhostAccountDetails = (ghostUId) => {
  const url = apiConstants.referrerGhostAccountDetails;
  return httpClient.get(url + ghostUId).then(result => result);
};


export { referrerGhostAccountDetails };
